module.exports = __webpack_public_path__ + "img/Left.15caa565.svg";